import {CONFIG_SET, ConfigAction, TICKETS_LOADING, TICKETS_SET} from "../actions/common";
import {Ticket} from "../models/hotels";

export type TicketMap = { [id: string]: Ticket }; // tslint:disable-line

export interface ConfigState {
    recaptchaSiteKey: string;
    buildHash: string;
    tickets: TicketMap;
    loading: boolean;
}

const initialState = (): ConfigState => {
    const cfg: any = ((window as any).psConfig) || {};
    return {
        recaptchaSiteKey: cfg.recaptchaSiteKey,
        buildHash: cfg.buildHash,
        tickets: {},
        loading: false,
    };
};

export function configReducer(state: ConfigState = initialState(), action: ConfigAction): ConfigState {
    switch (action.type) {
        case CONFIG_SET:
            return {
                ...state,
                ...action.config
            } as ConfigState;
        case TICKETS_SET:
            return {
                ...state,
                tickets: action.tickets,
                loading: false,
            } as ConfigState;
        case TICKETS_LOADING:
            return {
                ...state,
                loading: action.loading,
            } as ConfigState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/config.ts